function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { DropMenuEl } from "common/components/drop-menu";
import { ItemsMenuEl } from "common/components/items-menu";
import { TagEl } from "../tag";
import { TagSize, TagTheme } from "../tag/types";
import { InputEl } from "../input";
import { TagInputSearchMode } from "./types";
import tagStyle from "./tag.inline.styl";
function TagMenu() {
  var _this$state$searchInp;
  if (this.state.menuSections === null) {
    return null;
  }
  return /* @__PURE__ */ jsx(DropMenuEl, { attrs: {
    open: this.state.isMenuOpen,
    "prevent-close-selectors": [".mp-tag-input-input-wrapper"]
  }, on: {
    change: (ev) => this.handleTagMenuChange(ev)
  }, props: {
    positionParent: this.attr("search-mode") === TagInputSearchMode.Hashtag ? (_this$state$searchInp = this.state.searchInputEl) === null || _this$state$searchInp === void 0 ? void 0 : _this$state$searchInp.searchInput : this
  }, style: this.getDropMenuStyles(), "data-sentry-element": "DropMenuEl", "data-sentry-component": "TagMenu", "data-sentry-source-file": "template.tsx" }, this.state.isMenuOpen && /* @__PURE__ */ jsx(ItemsMenuEl, { sel: ".mp-tag-input-tag-menu", attrs: _objectSpread({
    elref: "mpTagInputTagMenu",
    "search-filter": this.getStagedTagSearch() || "",
    "empty-message": "No results"
  }, this.attr("mp-items-menu-attrs")), props: {
    sections: this.getMenuSections(),
    keydownProxyEl: this.state.searchInputEl,
    sectionsFromInputFn: this.state.sectionsFromInputFn
  }, on: {
    clickItem: (ev) => this.handleClickTagItem(ev)
  } }));
}
export function template() {
  const alwaysShowClear = Boolean(this.attr("show-clear") && (this.state.tagMap.size > this.attr("min-tags") || this.state.inputText));
  const tagEls = /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("style", null, tagStyle), Array.from(this.state.tagMap.values()).map((tag, index) => {
    return /* @__PURE__ */ jsx(TagEl, { sel: ".mp-tag-input-tag", class: {
      multiline: this.attr("multiline")
    }, attrs: _objectSpread({
      elref: "mpTagInputTag",
      tabindex: 0,
      removable: this.canRemoveTag(tag),
      size: TagSize.Small,
      "tag-name": tag.label,
      theme: this.state.isFocused ? TagTheme.Light : TagTheme.Secondary,
      "data-index": index
    }, tag.attrs), key: "tag-".concat(tag), on: {
      remove: () => this.canRemoveTag(tag) && this.removeTag(tag),
      keydown: (ev) => this.handleTagKeyDown(ev, {
        tag,
        index
      }),
      click: (ev) => ev.stopPropagation(),
      focus: (ev) => this.handleTagFocus(ev),
      blur: (ev) => this.handleTagBlur(ev)
    } });
  }));
  return /* @__PURE__ */ jsx("div", { sel: ".mp-tag-input-container", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(InputEl, { sel: ".mp-tag-input-search-input", attrs: _objectSpread(_objectSpread({}, this.getInputAttrs()), {}, {
    elref: "searchInput",
    placeholder: this.getPlaceholder(),
    "always-show-clear": alwaysShowClear
  }), params: {
    prefixRenderer: () => tagEls,
    suffixRenderer: this.state.suffixRenderer
  }, props: {
    value: this.state.inputText
  }, on: {
    focus: () => this.handleInputFocus(),
    blur: () => this.handleInputBlur(),
    input: (ev) => this.changeInputText(ev.target.value),
    clear: (ev) => this.handleClearInput(ev),
    keydown: (ev) => this.handleInputKeyDown(ev)
  }, hook: {
    insert: (vnode) => this.handleSearchInputInsert(vnode)
  }, "data-sentry-element": "InputEl", "data-sentry-source-file": "template.tsx" }), TagMenu.call(this));
}
